/**
 *
 * Public interface of Toast container
 *
 */

import { connect } from 'react-redux';

import Toast from './Toast';

import { hideToast } from '../../actions';

const mapDispatchToProps = { hideToast };

export default connect(
  null,
  mapDispatchToProps,
)(Toast);
